import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { TopicSpecialistRow } from '../topic-specialists-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<TopicSpecialistRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.accTopicSpecialistId, { header: 'accTopicSpecialistId' }),
		buildColumn(util, 'Id', row => row.accTopicId, { header: 'accTopicId' }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'topicId' }),
		buildColumn(util, 'Id', row => row.accSessionId, { header: 'accSessionId' }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'Text', row => row.topicName, { header: 'Topic' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.sessionStartUTC), { header: 'Session' }),
		buildColumn(util, 'Number', row => row.specialistSurveyResults, { header: '# Surveys', headerTooltip: 'Specialist Surveys Taken' }),
		buildColumn(util, 'Number', row => row.specialistSurveyProfessionalismScore, { header: 'Professionalism Score', headerTooltip: 'Professionalism Score [0-100] Asked: "The specialist was professional"', hidden: true }),
		buildColumn(util, 'Number', row => row.specialistSurveyKnowledgeScore, { header: 'Knowledge Score', headerTooltip: 'Knowledge Score [0-100] Asked: "The specialist was knowledgeable about this topic"', hidden: true }),
		buildColumn(util, 'Number', row => row.specialistSurveyEffectivenessScore, { header: 'Effectiveness Score', headerTooltip: 'Effectiveness Score [0-100] Asked: "The specialist effectively taught the topic"', hidden: true }),
	];


	return columns;

}